<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field  label="Search" placeholder="Search" class="px-1"
                     v-model="table_data.search"
                     clearable
                     flat dense
                     solo-inverted
                     hide-details
                     prepend-inner-icon="mdi-magnify"
                     @change="$router.replace({name: $route.name, query: {...$route.query, search: table_data.search}})"
      ></v-text-field>


<!--      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="table_data.search"></v-text-field>-->
<!--      <date-field input-class="mx-2" hide-details v-model="date_from"></date-field>-->
<!--      <date-field input-class="mx-2" hide-details v-model="date_to"></date-field>-->
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
         <v-card>
           <v-card-text class="text-center">
             <v-btn-toggle v-model="period" mandatory color="primary">
               <v-btn small value="default">Default</v-btn>
               <v-btn small value="last_month">Last month</v-btn>
<!--               <v-btn small value="today">Today</v-btn>-->
<!--               <v-btn small value="tomorrow">Tomorrow</v-btn>-->
               <!--                <v-btn small value="3month">3 months</v-btn>-->
               <!--                <v-btn small value="6month">6 months</v-btn>-->
               <!--                <v-btn small value="all">All</v-btn>-->
             </v-btn-toggle>
           </v-card-text>
           <v-divider/>
           <v-card-text>
             <date-field input-class="mx-2" flat dense solo-inverted label="From" v-model="date_from"/>
             <date-field input-class="mx-2" flat dense solo-inverted label="Till" v-model="date_to"/>

             <v-select label="Practice area" class="px-1"
                       :items="practice_areas"
                       v-model="table_data.practice_area"
                       item-value="id"
                       item-text="name"
                       clearable dense solo-inverted
                       @change="$router.replace({name: $route.name, query: {...$route.query, practice_area: table_data.practice_area}})"
             />
             <v-select label="Session type" class="px-1"
                       :items="session_types"
                       v-model="table_data.session_type"
                       item-value="id"
                       item-text="name"
                       clearable dense solo-inverted
                       @change="$router.replace({name: $route.name, query: {...$route.query, session_type: table_data.session_type}})"
             />
             <v-select label="Assigment status" class="px-1"
                       :items="assigment_status_opts"
                       v-model="assigment_status"
                       clearable dense solo-inverted
                       @change="$router.replace({name: $route.name, query: {...$route.query, assigment_status: assigment_status}})"
             />
           </v-card-text>
         </v-card>
        </v-col>

        <v-col cols="12" md="9">
          <v-card>
            <v-data-table :headers="table_data.headers"
                          :items="table_data_items"
                          :search="table_data.search"
                          :items-per-page="15"
            >
              <template v-slot:item.start="{ value }">
                {{ $moment(value).format('DD/MM/YYYY hh:mm A') }}
              </template>
              <template v-slot:item.deadline="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY hh:mm A') : null }}
              </template>
              <template v-slot:item.end="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY HH:mm') : null }}
              </template>
              <template v-slot:item.ready="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY HH:mm') : null }}
              </template>
              <template v-slot:item.return_marked="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY HH:mm') : null }}
              </template>
              <template v-slot:item.marked="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY HH:mm') : null }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn small color="primary" :to="{name: 'Session', params: {session_id: item.id}}">open</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    tutor: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    date_from: null,
    date_to: null,
    table_data: {
      headers: [
        { text: 'User', value: 'user.full_name' },
        { text: 'Email', value: 'user.email' },
        { text: 'Name', value: 'short_name' },
        // { text: 'Session type', value: 'session_type.name' },
        // { text: 'Practice area', value: 'practice_area.name' },
        { text: 'Start', value: 'start' },
        { text: 'Deadline', value: 'deadline' },
        { text: 'Ready', value: 'ready' },
        { text: 'Return marked', value: 'end' },
        { text: 'Marked', value: 'marked' },
        { text: 'Mark', value: 'final_mark' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      search: '',
    },
    period: 'default',
    period_opts: [
      'default',
      'last_month',
      'today',
      'tomorrow',
      '3month',
      '6month',
      'all',
    ],
    assigment_status: null,
    assigment_status_opts: [
      {text: 'Submitted for marking', value: 'submitted'},
      {text: 'Marked submissions', value: 'marked'},
    ],
    api_errors: [],
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    table_data_items: function () {
      let items = []

      items.push(...this.table_data.items)

      if(this.table_data.practice_area) {
        items = items.filter(item => item.practice_area_id === this.table_data.practice_area)
      }

      if(this.table_data.session_type) {
        items = items.filter(item => item.session_type_id === this.table_data.session_type)
      }

      if(this.assigment_status) {
        if (this.assigment_status === 'submitted') {
          items = items.filter(item => item.ready !== null && item.marked === null)
        }

        if (this.assigment_status === 'marked') {
          items = items.filter(item => item.ready !== null && item.marked !== null)
        }
      }

      return items
    },
  },
  watch: {
    'period': function (val) {
      switch(val) {
        case 'last_month':
          this.date_from = this.$currentTime().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
          break;
        case 'today':
          this.date_from = this.$currentTime().format('YYYY-MM-DD')
          this.date_to = this.$currentTime().format('YYYY-MM-DD')
          break;
        case 'tomorrow':
          this.date_from = this.$currentTime().add(1, 'days').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(1, 'days').format('YYYY-MM-DD')
          break;
        case '3month':
          this.date_from = this.$currentTime().subtract(3, 'month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
          break;
        case '6month':
          this.date_from = this.$currentTime().subtract(6, 'month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
          break;

          // case 'all':
          //   this.date_from = null
          //   this.date_to = null
          //   break;
        default:
          this.date_from = this.$currentTime().startOf('month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().endOf('month').format('YYYY-MM-DD')
      }
    },
    'date_from': function(val, oldVal) {
      if(oldVal !== null && val !== null){
        this.loadData()
      }
    },
    'date_to': function(val, oldVal) {
      if(oldVal !== null && val !== null){
        this.loadData()
      }
    },
  },
  created() {
    this.date_from = this.$currentTime().startOf('month').format('YYYY-MM-DD')
    this.date_to = this.$currentTime().endOf('month').format('YYYY-MM-DD')
    if(this.$route.query.search) this.table_data.search = this.$route.query.search
    if(this.$route.query.practice_area) this.table_data.practice_area = parseInt(this.$route.query.practice_area)
    if(this.$route.query.session_type) this.table_data.session_type = parseInt(this.$route.query.session_type)

    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/tutors/${this.$route.params.tutor_id}/payments`, {
        params:{date_from: this.date_from, date_to: this.date_to}
      })
          .then(({data}) => data.data)
    },
  }
}
</script>